import { IS_SMALL_LOAN_PROGRAM_PRODUCT_ENABLED } from 'constants/constants';

import {
  MAXIMUM_LOAN_AMOUNT_1_RANGE,
  MAXIMUM_LOAN_AMOUNT_2_RANGE,
  MAXIMUM_LOAN_AMOUNT_RANGE,
  MAXIMUM_STEP_LOAN_AMOUNT,
  MEDIUM_STEP_LOAN_AMOUNT,
  MIN_LOAN_FOR_PORTAL,
  MIN_LOAN_FOR_PORTAL_WITH_SMALL_LOAN_PROGRAM,
  MINIMUM_LOAN_AMOUNT,
  MINIMUM_STEP_LOAN_AMOUNT,
  STEP_1_RANGE,
  STEP_2_RANGE,
  STEP_3_RANGE,
} from './loanInformation.constants';

//Function for denormalising a value (returning it to the original range)
export const denormalizeLoanAmountSliderValue = (value: number) => {
  if (value <= STEP_1_RANGE) {
    return MINIMUM_LOAN_AMOUNT + (value / STEP_1_RANGE) * (MAXIMUM_LOAN_AMOUNT_1_RANGE - MINIMUM_LOAN_AMOUNT);
  } else if (value <= STEP_1_RANGE + STEP_2_RANGE) {
    return (
      MAXIMUM_LOAN_AMOUNT_1_RANGE +
      ((value - STEP_2_RANGE) / STEP_2_RANGE) * (MAXIMUM_LOAN_AMOUNT_2_RANGE - MAXIMUM_LOAN_AMOUNT_1_RANGE)
    );
  } else {
    return (
      MAXIMUM_LOAN_AMOUNT_2_RANGE +
      ((value - (STEP_1_RANGE + STEP_2_RANGE)) / STEP_3_RANGE) *
        (MAXIMUM_LOAN_AMOUNT_RANGE - MAXIMUM_LOAN_AMOUNT_2_RANGE)
    );
  }
};

export const roundToStep = (value: number) => {
  if (value <= MAXIMUM_LOAN_AMOUNT_1_RANGE) {
    return Math.round(value / MINIMUM_STEP_LOAN_AMOUNT) * MINIMUM_STEP_LOAN_AMOUNT; // Step $1,000 for $1,000 - $50,000
  } else if (value <= MAXIMUM_LOAN_AMOUNT_2_RANGE) {
    return Math.round(value / MEDIUM_STEP_LOAN_AMOUNT) * MEDIUM_STEP_LOAN_AMOUNT; // Step $2,000 for $50,000 - $150,000
  } else {
    return Math.round(value / MAXIMUM_STEP_LOAN_AMOUNT) * MAXIMUM_STEP_LOAN_AMOUNT; // Step $10,000 for $150,000 - $500,000
  }
};

// Function for normalising a value (bringing it to the range 0-100)
export const normalizeValue = (value: number) => {
  if (value <= MAXIMUM_LOAN_AMOUNT_1_RANGE) {
    return ((value - MINIMUM_LOAN_AMOUNT) / (MAXIMUM_LOAN_AMOUNT_1_RANGE - MINIMUM_LOAN_AMOUNT)) * STEP_1_RANGE;
  } else if (value <= MAXIMUM_LOAN_AMOUNT_2_RANGE) {
    return (
      STEP_1_RANGE +
      ((value - MAXIMUM_LOAN_AMOUNT_1_RANGE) / (MAXIMUM_LOAN_AMOUNT_2_RANGE - MAXIMUM_LOAN_AMOUNT_1_RANGE)) *
        STEP_2_RANGE
    );
  } else {
    return (
      STEP_1_RANGE +
      STEP_2_RANGE +
      ((value - MAXIMUM_LOAN_AMOUNT_2_RANGE) / (MAXIMUM_LOAN_AMOUNT_RANGE - MAXIMUM_LOAN_AMOUNT_2_RANGE)) * STEP_3_RANGE
    );
  }
};

export const checkUserShouldBeRedirectToFinMktPortal = (loanAmount: number) => {
  if (IS_SMALL_LOAN_PROGRAM_PRODUCT_ENABLED) {
    return loanAmount < MIN_LOAN_FOR_PORTAL_WITH_SMALL_LOAN_PROGRAM;
  }

  return loanAmount < MIN_LOAN_FOR_PORTAL;
};
